import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { FeedbackTrendDataProps } from "../../modules/admin/dashboard/type";
import { SharedFeedbacksParams } from "../../type";
import { get } from "../../util/APIService";
import { HttpStatus } from "../../enums/httpStatus";

export const getFeedbackTrendData = createAsyncThunk(
  "admin/feedback/trend",
  async (requestParams: SharedFeedbacksParams, storeActions) => {
    const url = `api/v1/admin/feedback/trend` + requestParams.requestingParams;
    const response: any = await get(url, storeActions);

    if (response.status === HttpStatus.OK) {
      return {
        status: HttpStatus.OK,
        data: await response.json(),
      };
    } else {
      return {
        status: response.status,
        text: await response.text(),
      };
    }
  }
);

const feedbackTrendSlice = createSlice({
  name: "feedbackTrend",
  initialState: {
    status: null as number | null,
    loading: false as boolean,
    text: null as string | null,
    data: [] as Array<FeedbackTrendDataProps> | null,
  },
  reducers: {
    clearData: (state) => {
      state.status = null;
      state.loading = false;
      state.text = null;
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getFeedbackTrendData.fulfilled, (state, action) => {
      state.status = action.payload.status;
      state.loading = false;
      if (action.payload.data !== undefined) {
        state.data = action.payload.data;
        state.text = null;
      } else if (action.payload.text !== undefined) {
        state.data = null;
        state.text = action.payload.text;
      }
    });
    builder.addCase(getFeedbackTrendData.pending, (state) => {
      state.status = null;
      state.loading = true;
      state.data = null;
      state.text = null;
    });
    builder.addCase(getFeedbackTrendData.rejected, (state) => {
      state.status = 503;
      state.loading = false;
      state.data = null;
      state.text = null;
    });
  },
});

export const { clearData } = feedbackTrendSlice.actions;

export default feedbackTrendSlice;
